module.exports = __webpack_public_path__ + "img/UNIFORM BW.c617694.svg";